import { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import GridTable from "../../../components/GridTable/GridTable";
import endpoints from "../../../services/endpoints";
import { useLocation, useNavigate } from "react-router";
import { setPreviousUrl } from "../../../store/slices/geolocationSlice";
import { useDispatch } from "react-redux";
import { setListOfUsers } from "../../../store/slices/selectedBankIdSlice";

export default function ListOfSuperAdminTransactions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { superAdminTransaction } = endpoints;
  const [searchPlaceholder, setSearchPlaceholder] = useState<string>('transaction id');
  const [isTransitioning, setIsTransitioning] = useState<boolean>(false);
  const TableDetails: { [key: string]: any } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Transaction Date and Time": {
      id: "transaction_date",
      custom: ["transaction_date"],
      className: "min-w-[248px]",
    },
    "User Name (User Code)": {
      id: "user_code",
      className: "min-w-[400px]",
    },
    "Transaction Type (Status)": {
      id: "transaction_category",
    },
    "Wallet": {
      id: "wallet_type",
      custom: ["wallet_type"],
    },
    Recipient: {
      id: "recipient",
    },
    "Recipient Location": {
      id: "recipient_location",
    },
    "MNO Name": {
      id: "mno_name",
    },
    "Amount": {
      id: "amount",
      custom: ["amount"],
    },
    Actions: {
      id: "actions",
      actionTypes: ["view"],
      className: "w-[100px]"
    }
  };
  const handleActions = async (id: string, key: string, text?: any) => {
    dispatch(setListOfUsers(location.pathname + location.search))
    navigate(`/zoodpay-money/super-admin-transactions/${id}`);
  };
  const staticText = {
    emptyScreenText: {
      heading1: "No Data",
      heading2: "No records found.",
    },
  };
  const dynamicFilterConfig: DynamicFilterConfig = {
    "Date Range": {
      label: "Date Range",
      type: "date",
      required: false,
      searchKey: {
        start: "transaction_start_date",
        end: "transaction_end_date",
      },
    },
  }
  const SEARCH_PLACEHOLDERS = [
    'user name',
    'user code',
    'transaction id',
  ] as const;

  const rotatePlaceholder = useCallback(() => {
    setIsTransitioning(true);

    setTimeout(() => {
      setSearchPlaceholder(prev => {
        const currentIndex = SEARCH_PLACEHOLDERS.indexOf(prev as typeof SEARCH_PLACEHOLDERS[number]);
        const nextIndex = (currentIndex + 1) % SEARCH_PLACEHOLDERS.length; // Loop cyclically
        return SEARCH_PLACEHOLDERS[nextIndex];
      });
      setIsTransitioning(false);
    }, 500);
  }, []);

  useEffect(() => {
    const interval = setInterval(rotatePlaceholder, 2500);
    return () => clearInterval(interval);
  }, [rotatePlaceholder]);
  return (
    <>
      <Breadcrumbs
        navPath={["Zoodpay Money", `List of Super Admin Transactions`]}
        heading={`List of Super Admin Transactions`}
        noNavigation={true}
        list={true}
      />
      <GridTable
        staticText={staticText}
        mainEndPoint={superAdminTransaction}
        TableDetails={TableDetails}
        handleActions={(id: string, key: string, text?: string) =>
          handleActions(id, key, text)
        }
        params={{ page_number: "1" }}
        searchPlaceholder={`Search by ${searchPlaceholder}`}
        placeholderClassName={`search-placeholder ${isTransitioning ? 'transitioning' : ''}`}
        filters={true}
        exporting={true}
        reportType="Balance Sheet"
        notfoundRoute={{ state: { route: `/zoodpay-money/super-admin-transactions` } }}
        title={`List of Super Admin Transactions `}
        hasViewMDPrivilege={true}
        addMorePadding={false}
        filterShimmer={true}
        dynamicFilterConfig={dynamicFilterConfig}
        customHeight="h-[103px]"
        forceFullWidth={true}
      />
    </>
  );
}
